<template>
  <img :src="companyLogoUrl" class="event-popup-company-logo" />
</template>

<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api';
import noImageIcon from '../../../images/noimage.png';

export default defineComponent({
  name: 'EventPopupCompanyLogo',
  props: {
    logoUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const companyLogoUrl = computed(() => props.logoUrl ?? noImageIcon);
    return {
      companyLogoUrl,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-company-logo {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid $oc-border;
}
</style>
